import { styled } from "styled-components";
import { colors } from "constants/colors";
import bt_left_n from "assets/images/bt_left_n.png";

interface Props {
  page: number;
  totalCount: number;
  $isFontWhite?: boolean; // 어두운 배경일때 active:white / total:gray
  $marginTop?: number;
  onClickPrev?: () => void;
  onClickNext?: () => void;
}

const PagingNav = ({
  page,
  totalCount,
  $isFontWhite,
  $marginTop = 16,
  onClickPrev,
  onClickNext,
}: Props) => {
  return (
    <StyledContainer $isFontWhite={$isFontWhite} $marginTop={$marginTop}>
      <button
        type="button"
        className="btn_prev"
        onClick={() => onClickPrev && onClickPrev()}
        disabled={page === 1}
      >
        이전
      </button>
      <p className="txt_page">
        <em className="txt_active">{page}</em> /{" "}
        <span className="txt_total">{totalCount}</span>
      </p>
      <button
        type="button"
        className="btn_next"
        onClick={() => onClickNext && onClickNext()}
        disabled={page === totalCount}
      >
        다음
      </button>
    </StyledContainer>
  );
};

export default PagingNav;

const StyledContainer = styled.div<{
  $marginTop: number;
  $isFontWhite?: boolean;
}>`
  display: flex;
  justify-content: center;
  margin-top: ${({ $marginTop }) => $marginTop}px;
  [class*="btn_"] {
    position: relative;
    width: 80px;
    height: 36px;
    border-radius: 20px;
    border: 1px solid ${colors.lightGray2};
    background-color: ${colors.white};
    font-size: 0;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 24px;
      height: 24px;
      mask: url(${bt_left_n}) no-repeat 0 0 / 24px;
      background-color: ${colors.black};
    }
    &.btn_next:after {
      transform: rotate(180deg);
    }
    &:disabled {
      opacity: 0.4;
    }
  }
  .txt_page {
    width: 46px;
    margin: 0 13px;
    font-size: 11px;
    line-height: 36px;
    letter-spacing: -0.55px;
    color: ${({ $isFontWhite }) =>
      $isFontWhite ? colors.gray : colors.subBody2};
    text-align: center;
  }
  .txt_active {
    color: ${({ $isFontWhite }) =>
      $isFontWhite ? colors.white : colors.black};
  }
`;
